import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import Modal from "../../utils/customModal";
import useApi from "../../hooks/useApi";
import { loadingHtml, errorContainer } from "../../utils/functions";
import { getSteps } from "./util";
import Disclaimer from "../../shared/Disclaimer/Disclaimer";

const refPaContract = "contractPaRequest";

const RegisterProvider = ({ initialState }) => {
  const [
    { currentStep, businessId, companyName, referenceNumber, ...state },
    setState,
  ] = useState(initialState);

  const [{ show, content }, setModal] = useState({
    show: false,
    content: null,
  });

  const { t } = useTranslation();
  const { postApiCAll } = useApi();

  const country = state.address.code;

  const steps = getSteps(country);

  const { Component, name, requestData } = steps[currentStep];

  const clearModal = (modalData = { content: null, show: false }) => {
    setModal(modalData);
  };

  const nextStep = async (value) => {
    try {
      if (requestData) {
        clearModal({ show: true, content: loadingHtml() });
        await postApiCAll("/providers/save-temporal-data", {
          ...requestData(value),
          step: String(currentStep + 1),
          referenceNumber,
          businessId,
        });
      }
      setState((prev) => ({
        ...prev,
        currentStep: prev.currentStep + 1,
        [name]: value || prev[name],
      }));

      clearModal();
    } catch (error) {
      clearModal({
        show: true,
        content: errorContainer("Error", t("registerProvider.error"), {
          continueBtn: { text: "Continuar", action: clearModal },
        }),
      });
    }
  };

  const previousStep = () => {
    setState((prev) => ({ ...prev, currentStep: prev.currentStep - 1 }));
  };

  const title = t(
    `registerProvider.${
      titles[currentStep === 0 ? "a" : name === refPaContract ? "c" : "b"]
    }`
  );

  const reviewMode = name === undefined;

  const props = {
    nextStep,
    previousStep,
    country,
    institution: businessId,
    initialState: reviewMode ? state : state[name],
    ...(reviewMode && { referenceNumber }),
  };

  const phases = [...Array(steps.filter(({ name }) => name).length).keys()];

  return (
    <>
      <div className="content">
        {!reviewMode && (
          <>
            <Disclaimer containerClass={"onboarding-steps"}>
              <p>{t("disclaimer.split_text.text_1")}</p>
              <p>{t("disclaimer.split_text.text_2")}</p>
              <p>{t("disclaimer.split_text.text_3")}</p>
            </Disclaimer>

            <div className="step-header">
              <h4 className="step-description">
                {title}
                <span>
                  (Paso {currentStep + 1} de {phases.length})
                </span>
              </h4>
              <div className="step-phases">
                {phases.map((key) => (
                  <div
                    className={`${key <= currentStep ? "phase-active" : ""}`}
                    key={key}
                  />
                ))}
              </div>
            </div>
            <div className="register-provider-details">
              <h4 className="title">{t(`${baseName}title`)}</h4>
              <div className="detail">
                <h4 className="subtitle">{t(`${baseName}name`)}</h4>
                <h6 className="description">{companyName}</h6>
              </div>
              <div className="detail">
                <h4 className="subtitle">{t(`${baseName}id`)}</h4>
                <h6 className="description">{businessId}</h6>
              </div>
            </div>
          </>
        )}
        <div className="form-container d-flex align-items-center flex-column">
          <Component {...props} />
        </div>
      </div>
      <Modal show={show}>{content}</Modal>
    </>
  );
};

export default RegisterProvider;

const baseName = "registerProvider.details.";

const titles = {
  a: "firstTitle",
  b: "registerUserTitle",
  c: "contractTitle",
};
